<gsp-checkbox
    [(value)]="value"
    [disabled]="!enabled"
    [helpText]="hintText"
    [hidden]="!visible"
    [id]="name"
    [label]="label"
></gsp-checkbox>
